var cslSocialShares = {
    openURLInPopup: function (url, name, w, h) {
        if (typeof(w) == "undefined") {
            w = 575;
            h = 400;
        }
        if (typeof(h) == "undefined") {
            h = 400;
        }
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;
        var newWindow = window.open(url, name || 'window' + Math.floor(Math.random() * 10000 + 1),
            'menubar=0,toolbar=0,status=0,scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
    },
    email: function (data) {
        window.location.href = data.shareUrl;
    }
};
var player;

function onYouTubeIframeAPIReady() {
    jQuery('.video-banner.external.youtube').each(function (i, item) {
        if ( ! jQuery(item).attr('id') ) {
           jQuery(item).attr('id', Math.round(new Date().getTime() + (Math.random() * 100)));
        }
        player = new YT.Player(jQuery(item).attr('id'), {
            videoId: jQuery(item).data('external-video-id'),
            playerVars: {
                autoplay: 1,
                controls: 0,
                disablekb: 1,
                loop: 1,
                showinfo: 0,
                autohide: 1,
                rel: 0
            },
            events: {
                'onReady': function (e) {
                    e.target.mute();
                    jQuery('.video-banner.external.youtube').attr('data-video-width', jQuery('.video-banner.external.youtube').attr('width'));
                    jQuery('.video-banner.external.youtube').attr('data-video-height', jQuery('.video-banner.external.youtube').attr('height'));
                    jQuery(window).resize();
                },
                'onStateChange': function (e) {
                    if (e.data === YT.PlayerState.ENDED) {
                        e.target.playVideo();
                    }
                }
            }
        });
    });
    jQuery('.video-bg.video_link.youtube').each(function (i, item) {
        if ( ! jQuery(item).attr('id') ) {
           jQuery(item).attr('id', Math.round(new Date().getTime() + (Math.random() * 100)));
        }
        player = new YT.Player(jQuery(item).attr('id'), {
            videoId: jQuery(item).data('external-video-id'),
            playerVars: {
                autoplay: 1,
                controls: 0,
                disablekb: 1,
                loop: 1,
                showinfo: 0,
                autohide: 1,
                rel: 0
            },
            events: {
                'onReady': function (e) {
                    e.target.mute();
                    jQuery('.video-bg.video_link.youtube').attr('data-video-width', jQuery('.video-bg.video_link.youtube').attr('width'));
                    jQuery('.video-bg.video_link.youtube').attr('data-video-height', jQuery('.video-bg.video_link.youtube').attr('height'));
                    jQuery(window).resize();
                },
                'onStateChange': function (e) {
                    if (e.data === YT.PlayerState.ENDED) {
                        e.target.playVideo();
                    }
                }
            }
        });
    });
}
function adjustVideoTeasers(){
    jQuery('.supra-wrapper').each(function(i,item){
        adjustVideoTeaserSize(jQuery(item));
    });
}
function adjustVideoTeaserSize(item){
    var newDimensions = imageInside({
        containerWidth:jQuery(item).width(),
        containerHeight:jQuery(item).height(),
        imageWidth:360,
        imageHeight:270});
    jQuery(item).find("video").css(newDimensions);
}
function initializeVilynx(){

    if(typeof vilynx_public_key!='undefined'){
        var fileRef = document.createElement('script');
        fileRef.setAttribute("type", "text/javascript");
        fileRef.setAttribute("src",  "//static.vilynx.com/gallery/vpg.4.1.2.min.js");
        fileRef.setAttribute("data-publickey", vilynx_key);
        fileRef.setAttribute("data-optimizely", "true");
        document.body.appendChild(fileRef);

        jQuery(window).resize();
        jQuery('.featured-img.popup-video').mouseover(function(e){
            adjustVideoTeaserSize(jQuery(this).find(".supra-wrapper"));
        });
    }
}

(function ($, root, undefined) {

    $(function () {

        'use strict';

        $(window).ready(function () {

            initializeVilynx();
            $(window).resize(adjustVideoTeasers);

        });

        /* *****************************
         * MATCH HEIGHT CLASS
         * *****************************
         */
        $(window).load(function () {

            $('.match-height').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });

            $('.grid-item').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });

            $('.team-item').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
            $('.event-item').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
            $('.event-item .title').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });

            $(window).resize();
            adjustVideoTeasers();

        });


        /* *****************************
         * FULL HEIGHT
         * *****************************
         */
        function fullHeight() {
            //debugger;
            var totalHeight = parseInt($(window).height());
            //var headerHeight = $('.header').outerHeight();
            //var footerHeight = $('.footer').outerHeight();
            var fullHeight = totalHeight;
            $('.full-height').css('height', fullHeight);
            $('.banner-full-height').css('min-height', fullHeight);
        }

        fullHeight();


        /* *****************************
         * STICKY MENU
         * *****************************
         */
        var menu = $('.header.sticky');
        if (menu.length > 0) {
            // Cada vez que se haga scroll en la página
            // haremos un chequeo del estado del menú
            // y lo vamos a alternar entre 'fixed' y 'static'.
            $(window).on('scroll', function () {
                if ($(window).scrollTop() > 0) {
                    $('.header.sticky').addClass('fixed-menu');
                    if ( !$('.top-search .search-input').hasClass('show-hidden') && $(window).width() > 992 ) {
                        topSearchForm.trigger('close');
                    }
                } else {
                    $('.header.sticky').removeClass('fixed-menu');
                }
            });
        }
        /* *****************************
         * TOGGLE MENU
         * *****************************
         */
        $('.header .toggle-menu').click(function (e) {
            e.preventDefault();
            $('.csl-wrapper').toggleClass('visible-nav');
            menuHeight();
            $('.main-navigation').slideToggle();
            $('.social-media-links').slideToggle();
        });

        /* *****************************
         * FULL HEADER WIDTH
         * *****************************
         */
        function navWidth() {
            //debugger;
            var headerWidth = $('.header-full .container').outerWidth();
            var logoWidth = $('.header-logo').outerWidth();
            var topSearchWidth = $('.top-search').outerWidth();
            var navigationWidth = headerWidth - logoWidth - topSearchWidth
            if ($(window).width() > 992) {
                $('.header-full .container .main-navigation').css('max-width', navigationWidth);
            } else {
                $('.header-full .container .main-navigation').css({
                    "max-width": "initial",
                    "width": "100%"
                });
            }
        }

        navWidth();

        /* *****************************
         * SCROLLABLE MENU:
         * Menu container height controller. It's using a div width a class called
         * csl-wrapper, that is just a container for keeping main nav scrollable in mobile
         * *****************************
         */
        function menuHeight() {
            //debugger;
            var totalHeight = parseInt($(window).height());
            var headerHeight = $('.header-logo').outerHeight();
            var socialHeight = $('.header-container .social-media-links').outerHeight();
            var divHeight = totalHeight - headerHeight - socialHeight
            if ($(window).width() < 993) {
                $('.header .header-container .main-navigation .menu').css({
                    "height": divHeight
                });
            } else {
                $('.header .header-container .main-navigation .menu').css({
                    "height": "initial"
                });
            }
        }

        menuHeight();

        /* *****************************
         * TOGGLE TOP SEARCH BAR
         * *****************************
         */
        var topSearchForm = $('.top-search .search');
        var topSearchInput = topSearchForm.children('.search-input');
        var topSearchButton = topSearchForm.children('button');


        /* TOP SEARCH INPUT DYNAMIC WIDTH */
        function setSearchInputWidth() {
            //debugger;
            var headerWidth = $('.header .header-container').outerWidth();
            var logoWidth = $('.header-logo').outerWidth();
            var topSearchWidth = $('.top-search').outerWidth();
            var navWidth = headerWidth - logoWidth - searchWidth // Used in header full width
            if ($(window).width() <= 992) {
                var searchWidth = headerWidth - topSearchWidth;
            }
            else {
                var searchWidth = headerWidth - logoWidth - topSearchWidth;
            }
            topSearchInput.css('width', searchWidth);
        }
        ;

        topSearchForm.bind('close', function () {

            topSearchInput.addClass('show-hidden').css('width', '0');
            topSearchButton.removeClass('active');
            topSearchButton.children('i')
                .removeClass('fa-times fa-paper-plane')
                .addClass('fa-search');
        });

        topSearchButton.on('mousedown', function (e) {
            console.log('mousedown');
            var self = $(this);
            if (self.hasClass('active')) {
                self.data('buttonClosedForm', true);
            }
        }).on('click', function (e) {
            console.log('click');
            var self = $(this);

            if (self.data('buttonClosedForm') || self.hasClass('active')) {
                // The search form is open, active
                if (topSearchInput.val() == '') {
                    e.preventDefault();
                    topSearchForm.trigger('close');
                }
                console.log('closing');
                self.data('buttonClosedForm', false);
            } else {
                // The search form is closed, let's open it

                e.preventDefault();
                setSearchInputWidth();
                self.addClass('active');
                self.children('i')
                    .removeClass('fa-search fa-paper-plane')
                    .addClass('fa-times active');

                topSearchInput
                    .val('')
                    .trigger('focus')
                    .removeClass('show-hidden');
            }
        });

        topSearchInput.on('focusout', function (e) {
            if (!topSearchButton.data('buttonClosedForm')) {
                topSearchForm.trigger('close');
            }
        }).on('keyup', function (e) {
            var self = $(this);
            if (e.which == 27) {
                self.trigger('focusout');
            }
            if (!topSearchButton.hasClass('active')) {
                return;
            }
            if (self.val() != '') {
                topSearchButton.children('i').removeClass('fa-times').addClass('fa-paper-plane');
            } else {
                topSearchButton.children('i').addClass('fa-times').removeClass('fa-paper-plane');
            }
        });
        /* *****************************
             * SIDE NAV SEARCH
         * *****************************
         */
        $('#search-overlay form input').focus(function () {
            $(this).parent().addClass('active');
        }).blur(function () {
            $(this).parent().removeClass('active');
        });
        $('#search-btn').on("click", function (event) {
            event.preventDefault();
            $("#search-overlay").addClass("active");
            $('body').addClass("active-search");

        });

        $("#search-overlay, #search-overlay .close").on("click keyup", function (event) {
            if (
                event.target == this ||
                event.target.className == "close" ||
                event.keyCode == 27
            ) {
                $(this).removeClass("active");
                $('body').removeClass("active-search");

            }
        });
        /* *****************************
             * SIDE NAV
         * *****************************
         */
        //SUBMENU TRIGGER
        $(window).load(function () {
            renderMenu()
        });
        $(window).resize(renderMenu);
        var isActive = false;

        function renderMenu() {
            if ($(window).width() > 300) {
                if (isActive) return;
                $('.sidebar-menu .main-navigation ul .menu-item-has-children').prepend('<button href="#" class="submenu-trigger"></button>');
                $('.sidebar-menu .main-navigation ul .menu-item-has-children').removeClass('expanded');
                $('.sidebar-menu .main-navigation ul .menu-item-has-children').find('> .sub-menu').slideUp();
                isActive = true;
                addHandlers();
                openCurrentSubmenu();
                addFloatingClass();

            } else {
                if (!isActive) return;
                // $('.sidebar-menu .main-navigation ul .menu-item-has-children button.submenu-trigger').remove();
                $('.sidebar-menu .main-navigation ul ').css("display", "");
                $('.sidebar-menu .main-navigation ul .menu-item-has-children').removeClass('expanded');
                $('.sidebar-menu .main-navigation ul .menu-item-has-children').find('> ul.sub-menu').slideDown();
                isActive = false;
            }
        }

        //Adding handlers
        function addHandlers() {
            $('.submenu-trigger').on("click", function (e) {
                e.preventDefault();
                if ($(this).closest('.sidebar-menu .main-navigation ul li').hasClass('expanded')) {
                    $(this).closest('.sidebar-menu .main-navigation ul li').removeClass('expanded');
                    $(this).closest('.sidebar-menu .main-navigation ul li').find('> ul.sub-menu').slideUp();

                } else {
                    $(this).closest('.sidebar-menu .main-navigation ul li').addClass('expanded');
                    $(this).closest('.sidebar-menu .main-navigation ul li').find('> ul.sub-menu').slideDown();
                }
            });
        };

        //Open Current Submenus
        function openCurrentSubmenu() {
            if ($('.sidebar-menu .main-navigation ul .menu-item-has-children.current-menu-ancestor').hasClass('current-menu-parent')) {
                $('.sidebar-menu .main-navigation ul .menu-item-has-children.current-menu-ancestor').addClass('expanded');
                $('.sidebar-menu .main-navigation ul .menu-item-has-children.current-menu-ancestor').find('> ul.sub-menu').slideDown();
            } else {
                //do nothing
            }
        }

        //Add default classes
        function addFloatingClass() {
            if ($('#sidebar-menu').hasClass('open-menu')) {
                $('.floating-button-container').addClass('active open-menu');
            } else {
                $('.floating-button-container').removeClass('active');
            }
        }

        function openNav() {
            $('#sidebar-menu').addClass('open-menu');
            $('#csl-wrapper').addClass('open-menu');
            $('.toggle-menu').addClass('open-menu');
            $('.floating-button-container').addClass('open-menu');
            $('#sidebar-menu').removeClass('close-menu');
            $('#csl-wrapper').removeClass('close-menu');
            $('.toggle-menu').removeClass('close-menu');
            $('.floating-button-container').removeClass('close-menu');
        }

        function closeNav() {
            $('#sidebar-menu').removeClass('open-menu');
            $('#csl-wrapper').removeClass('open-menu');
            $('.toggle-menu').removeClass('open-menu');
            $('.floating-button-container').removeClass('open-menu');
            $('#sidebar-menu').addClass('close-menu');
            $('#csl-wrapper').addClass('close-menu');
            $('.toggle-menu').addClass('close-menu');
            $('.floating-button-container').addClass('close-menu');
        }

        function toggleMenu() {
            if ($('#sidebar-menu').hasClass('open-menu')) {
                closeNav();
            } else {
                openNav();
            }
        };
        $('.toggle-menu').on('click', toggleMenu);

        //making sidebar fixed menu when scroll
        var menu = $('#sidebar-menu');

        if (menu.length > 0) {
            var menu_offset = menu.offset();
            $(window).on('scroll', function () {
                if ($(window).scrollTop() > menu_offset.top) {
                    menu.addClass('fixed-menu');
                } else {
                    menu.removeClass('fixed-menu');
                }
            });
        }
        //Mobile width
        function mobileWidth() {
            if ($(window).width() < 992) {
                closeNav();
                $('body').addClass('open-menu');
                $('#sidebar-menu').addClass('mobile-menu');
                $('.toggle-menu').addClass('mobile-menu');
            } else {
                openNav();
                $('body').removeClass('open-menu');
                $('#sidebar-menu').removeClass('mobile-menu');
                $('.toggle-menu').removeClass('mobile-menu');
            }
        }
        $(window).resize(mobileWidth);


        /* *****************************
         * POPULAR CATEGORIES
         * *****************************
        */

        $('.popular-categories .title').click(function (e) {
            if ($(window).width() < 768) {
                e.preventDefault();
                $('.popular-categories .menu-ul').slideToggle(function () {
                    if ($(this).is(':visible'))
                        $(this).css('display', 'inline-block');
                });
            }
        });

        /* *****************************
         * CSL SLIDER
         * *****************************
         */
        $('.csl-slider[data-slider-type="slick"]').slick();
        $('.testimonials-slider').slick();

        /**
         * Vertically center Bootstrap 3 modals so they aren't always stuck at the top
         */
        $(function () {
            function reposition() {
                var modal = $(this),
                    dialog = modal.find('.modal-dialog');
                modal.css('display', 'block');

                // Dividing by two centers the modal exactly, but dividing by three
                // or four works better for larger screens.
                dialog.css("margin-top", Math.max(0, ($(window).height() - dialog.height()) / 2));
            }

            // Reposition when a modal is shown
            $('.modal').on('show.bs.modal', reposition);
            // Reposition when the window is resized
            $(window).on('resize', function () {
                $('.modal:visible').each(reposition);
            });
        });

        /* *****************************
         * ACTIVATE FORM BUTTONS ON CHANGE
         * *****************************
         */
        $("form").attr('autocomplete', 'off');

        function validateEmail(sEmail) {
            var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
            if (filter.test(sEmail)) {
                return true;
            }
            else {
                return false;
            }
        }

        $(".ninja-forms-form :input[type='submit']").prop('disabled', true);
        $('.ninja-forms-form .ninja-forms-req').keyup(function () {
            //debugger;
            var validEmailInput = false;
            if ($(this).hasClass('email')) {
                validEmailInput = validateEmail($(this).val());
            }

            if ($(this).val() != '' && validEmailInput == true) {
                $('.submit-wrap').addClass('active');
                $('.submit-wrap input[type="submit"]').prop('disabled', false);
            } else {
                $('.submit-wrap').removeClass('active');
                $('.submit-wrap input[type="submit"]').prop('disabled', true);
            }
        });

        /* *****************************
         * RESIZE FUNCTION
         * *****************************
         */
        $(window).resize(function () {
            fullHeight();
            navWidth();
            //menuHeight();
            if (topSearchButton.hasClass('active')) {
                setSearchInputWidth();
            }

            if ($('.header .main-navigation').is(":visible")) {
                if ($(window).width() <= 769) {
                    $('.header .social-media-links').css('display', 'block');
                }
                else {
                    $('.header .social-media-links').css('display', 'inline-flex');
                    $('.header .header-container .main-navigation .menu').css({
                        "height": "initial"
                    });
                }
            } else if ($('.header .main-navigation').is(":hidden")) {
                $('.header .social-media-links').css('display', 'none');
            }
        });

        /* *****************************
         * LOAD MORE FUNCTION
         * *****************************
         */
        $('.csl-theme').on('click', '[data-role="load-more-button"]', function (event) {
            var self = $(this);
            
            if (!self.data('loading')) {

                $(this).data('loading', true);
                var extra_params = self.data('extra-params');

                jQuery.ajax({
                    url: ajaxurl,
                    type: 'GET',
                    cache: false,
                    data: {
                        action: self.data('ajax-action'),
                        page: self.data('next-page'),
                        posts_per_page: self.data('posts-per-page'),
                        extra_params: extra_params,
                        post_type: self.data('post-type')
                    },
                    beforeSend: function () {
                        self.addClass('btn-loading');
                    },
                    complete: function () {
                        self.removeClass('btn-loading');
                        self.data('loading', false);
                    },
                    success: function (data) {
                        
                        if(!data){
                            self.hide();
                        }
                        
                        var next_page = self.data('next-page');
                        if (next_page >= self.data('max-num-pages')) {
                            self.hide();
                        }
                        self.data('next-page', next_page + 1);
                        data = jQuery(data);
                        data.each(function(e){jQuery(this).css('opacity',0)});
                        self.parent().children('.posts').append(data);
                        var previousMaintainScroll = $.fn.matchHeight._maintainScroll;
                        $.fn.matchHeight._maintainScroll = true;

                        $('.grid-item').matchHeight({
                            byRow: true,
                            property: 'height',
                            target: null,
                            remove: false
                        });
                        $.fn.matchHeight._maintainScroll = previousMaintainScroll;
                        data.each(function(e){jQuery(this).animate({ opacity: 1 }, 500)});
                    }
                });
            }
            event.preventDefault();
        });


        /* *****************************
         * PARALLAX EFFECT
         * *****************************


        $(window).on('scroll resize', function () {
                if(!isMobile.any()){

                    var st = jQuery(document).scrollTop();

                    $('.parallax').each(function(i,item){
                       var imgW = $(item).data('image-width');
                       var imgH = $(item).data('image-height');
                       var contW = $(item).width();
                       var contH = $(item).height();
                       var contT = $(item).offset().top;
                       var contL = $(item).offset().left;

                       var contTop = $(item).offset().top;
                       var percent_top = (st)/(contTop+contH);

                       var newContH = contTop+contH;
                       if(contTop>$(window).height()){
                           newContH = $(window).height();
                       }

                       var newSize = imageInside({containerWidth:contW, containerHeight:newContH, imageWidth:imgW, imageHeight:imgH});

                       var newTop = -100*percent_top;
                       if(contTop>$(window).height()){
                           newTop = 0;
                       }

                        $(item)
                        .css('background-size', (newSize.width)+'px '+newSize.height+'px')
                        .css('background-attachment','fixed')
                        .css('background-position', (contL+newSize.left)+'px '+newTop+'px');

                    });
                }
            }
        );
        $(window).scroll();
        */
        $('.parallax-csl').parallax("50%", 0.1);


        /* *****************************
         * MODAL DATA SETUP
         * *****************************
         */
        $('#generic-modal').on('show.bs.modal', function (e) {

            //get data-id attribute of the clicked element
            var title = $(e.relatedTarget).data('title');
            var content = $(e.relatedTarget).data('content');

            //populate the textbox
            $(e.currentTarget).find('.modal-title').html(title);
            $(e.currentTarget).find('.modal-body').html(content);
        });

        $('#events-modal').on('show.bs.modal', function (e) {

            //get data-id attribute of the clicked element
            var title = $(e.relatedTarget).data('title');
            var content = $(e.relatedTarget).data('content');

            var address = $(e.relatedTarget).data('address');
            var date = $(e.relatedTarget).data('date-content');

            //populate the textbox
            $(e.currentTarget).find('.modal-title').html(title);
            $(e.currentTarget).find('.modal-body').html(content);

            if (date) {
                $(e.currentTarget).find('.modal-event-details .date-container').show();
                $(e.currentTarget).find('.modal-event-details .date').html(date);
            } else {
                $(e.currentTarget).find('.modal-event-details .date-container').hide();
            }

            if (address) {
                $(e.currentTarget).find('.modal-event-details .address-container').show();
                $(e.currentTarget).find('.modal-event-details .address').html(address);
            } else {
                $(e.currentTarget).find('.modal-event-details .address-container').hide();
            }

        });

        $('.team-member-thumbnail').on('click', function (e) {

            //get data-id attribute of the clicked element
            var name = $(this).data('title');
            var description = $(this).data('content');
            var image = $(this).data('image');
            var position = $(this).data('job-position');
            var social = $(this).data('tmid');

            //populate the textbox
            var $teamModal = $('#team-modal');
            $teamModal.find('.name').html('').html(name);
            $teamModal.find('.description').html('').html(description);
            $teamModal.find('.photo').attr('src', image);
            $teamModal.find('.job-position').html('').html(position);
            $teamModal.find('.social').html('')
            if (typeof $('#sn-' + social).html() !== 'undefined') {
                $teamModal.find('.social').html('<ul>' + $('#sn-' + social).html() + '</ul>');
            }

        });

        $('.gallery-item-thumbnail').on('click', function (e) {

            //get data-id attribute of the clicked element
            var name = $(this).data('title');
            var description = $(this).data('description');
            var image = $(this).data('image');

            //populate the textbox
            var $imageModal = $('#image-modal');
            $imageModal.find('.name').html('').html(name);
            $imageModal.find('.description').html('').html(description);
            $imageModal.find('.photo').attr('src', image);

        });

        /*********************************
         * SOCIAL SHARES
         */

        $('.share-section').find('[data-role="share"]').on('click', function (e) {
            var dataType = $(this).data('share-type');
            var shareUrl = $(this).data('share-url');
            if (typeof(cslSocialShares[dataType]) != 'undefined') {
                cslSocialShares[dataType]($(this).data());
                e.preventDefault();
            } else if (shareUrl != '') {
                cslSocialShares.openURLInPopup(shareUrl);
                e.preventDefault();
            }

        });

        /* *****************************
        * BACK BUTTON
        * *****************************
        */
        $("[data-role='history-back']").click(function (e) {
            if (document.referrer != "") {
                history.back();
                e.preventDefault();
            }
        });

        /* *****************************
        * COUNTER ANIMATION
        * *****************************
        */
        $('.counterTo').countTo();


        /* *****************************
        * VIDEO BACKGROUND
        * *****************************
        */

        $('.csl-play-video').on('click', function (e) {
            var type = $(this).data('type');

            if(type == 'popup') {
                var popupContent = $(this).data('content');
                var url = "//www.youtube.com/watch?v=" + popupContent;
                var featuredContentVideo = lity(url);
            } else {
                var video_wrapper = $(this).closest('section').find('.video-bg-wrapper');
                video_wrapper.first().show();
                $(this).closest('section').find('.image-container').first().hide();

                var video_banner_div = video_wrapper.find('.video-banner-alt');
                if ( jQuery(video_banner_div).attr('id') === 'vp_') {
                    jQuery(video_banner_div).attr('id', Math.round(new Date().getTime() + (Math.random() * 100)));
                }
                console.log(jQuery(video_banner_div).attr('id'));
                if (jQuery(video_banner_div).hasClass('external')) {
                    if (jQuery(video_banner_div).hasClass('youtube')) {

                        player = new YT.Player(jQuery(video_banner_div).attr('id'), {
                            videoId: jQuery(video_banner_div).data('external-video-id'),
                            playerVars: {
                                autoplay: 1,
                                controls: 1,
                                disablekb: 0,
                                loop: 1,
                                showinfo: 0,
                                autohide: 1,
                                rel: 0
                            },
                            events: {
                                'onReady': function (e) {
                                    e.target.unMute();
                                    video_banner_div.attr('data-video-width', video_banner_div.attr('width'));
                                    video_banner_div.attr('data-video-height', video_banner_div.attr('height'));
                                    jQuery(window).resize();
                                },
                                'onStateChange': function (e) {
                                    if (e.data === YT.PlayerState.ENDED) {
                                        e.target.playVideo();
                                    }
                                }
                            }
                        });
                    }
                    if (jQuery(video_banner_div).hasClass('vimeo')) {
                        var options = {
                            id: jQuery(video_banner_div).data('external-video-id'),
                            loop: true,
                            autoplay: true
                        };

                        var player = new Vimeo.Player(jQuery(video_banner_div).attr("id"), options);

                        player.setVolume(0);

                        Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(function (dimensions) {
                            video_banner_div.attr('data-video-width', dimensions[0]);
                            video_banner_div.attr('data-video-height', dimensions[1]);
                            jQuery(window).resize();
                        });
                    }
                }
            }
        });

        if (!isMobile.any() || true ) {

            jQuery('.video-banner').each(function (i, item) {
                if (jQuery(item).hasClass('local')) {
                    var videoSources = !isUndefined(jQuery(item).data('video-mp4')) ? objectToTag('source', {
                        src: jQuery(item).data('video-mp4'),
                        type: 'video/mp4'
                    }) : '';
                    videoSources += !isUndefined(jQuery(item).data('video-ogg')) ? objectToTag('source', {
                        src: jQuery(item).data('video-ogg'),
                        type: 'video/ogg'
                    }) : '';
                    videoSources += !isUndefined(jQuery(item).data('video-webm')) ? objectToTag('source', {
                        src: jQuery(item).data('video-webm'),
                        type: 'video/webm'
                    }) : '';

                    var videoAttrs = {
                        id: jQuery(item).data('id'),
                        class: 'video-js vjs-fullscreen',
                        width: '100%', height: '100%', autoplay: '', loop: '', preload: 'auto'
                    };

                    var videoW = objectToTag('video', videoAttrs, videoSources);


                    jQuery(item).html(videoW);
                    videojs(jQuery(item).data('id'), {}, function () {
                        this.volume(0);
                        this.on('loadedmetadata', function () {
                            jQuery('.video-banner.local').attr('data-video-width', document.getElementById("opening-video_html5_api").videoWidth);
                            jQuery('.video-banner.local').attr('data-video-height', document.getElementById("opening-video_html5_api").videoHeight);
                            jQuery(window).resize();
                        });
                    });

                } else if (jQuery(item).hasClass('external')) {

                    if (jQuery(item).hasClass('vimeo')) {
                        if ( ! jQuery(item).attr('id') ) {
                          jQuery(item).attr('id', Math.round(new Date().getTime() + (Math.random() * 100)));
                        }
                        var options = {
                            id: jQuery(item).data('external-video-id'),
                            loop: true,
                            autoplay: true
                        };

                        var player = new Vimeo.Player(jQuery(item).attr("id"), options);

                        player.setVolume(0);

                        Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(function (dimensions) {
                            jQuery('.video-banner.external.vimeo').attr('data-video-width', dimensions[0]);
                            jQuery('.video-banner.external.vimeo').attr('data-video-height', dimensions[1]);
                            jQuery(window).resize();
                        });
                    }
                }
            });
            jQuery('.video-bg').each(function (i, item) {
                if (jQuery(item).hasClass('video_upload')) {
                    var id = jQuery(item).data('id') + Math.round(new Date().getTime() + (Math.random() * 100))
                    var videoSources = !isUndefined(jQuery(item).data('video-mp4')) ? objectToTag('source', {
                        src: jQuery(item).data('video-mp4'),
                        type: 'video/mp4'
                    }) : '';
                    videoSources += !isUndefined(jQuery(item).data('video-ogg')) ? objectToTag('source', {
                        src: jQuery(item).data('video-ogg'),
                        type: 'video/ogg'
                    }) : '';
                    videoSources += !isUndefined(jQuery(item).data('video-webm')) ? objectToTag('source', {
                        src: jQuery(item).data('video-webm'),
                        type: 'video/webm'
                    }) : '';

                    var videoAttrs = {
                        id: id,
                        class: 'video-js vjs-fullscreen',
                        width: '100%', height: '100%', autoplay: '', loop: '', preload: 'auto'
                    };

                    var videoW = objectToTag('video', videoAttrs, videoSources);


                    jQuery(item).html(videoW);
                    videojs(id, {}, function () {
                        this.volume(0);
                        this.on('loadedmetadata', function () {
                            jQuery('.video-bg.video_upload').attr('data-video-width', document.getElementById("opening-video_html5_api").videoWidth);
                            jQuery('.video-bg.video_upload').attr('data-video-height', document.getElementById("opening-video_html5_api").videoHeight);
                            jQuery(window).resize();
                        });
                    });

                } else if (jQuery(item).hasClass('video_link')) {

                    if (jQuery(item).hasClass('vimeo')) {
                        if ( ! jQuery(item).attr('id') ) {
                          jQuery(item).attr('id', Math.round(new Date().getTime() + (Math.random() * 100)));
                        }
                        var options = {
                            id: jQuery(item).data('external-video-id'),
                            loop: true,
                            autoplay: true
                        };

                        var player = new Vimeo.Player(jQuery(item).attr("id"), options);

                        player.setVolume(0);

                        Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(function (dimensions) {
                            jQuery('.video-bg.video_link.vimeo').attr('data-video-width', dimensions[0]);
                            jQuery('.video-bg.video_link.vimeo').attr('data-video-height', dimensions[1]);
                            jQuery(window).resize();
                        });
                    }
                }
            });

            // GET YOUTUBE API
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        } else {
            //jQuery(".video-bg-wrapper").hide();
        }

        jQuery(window).resize(function () {
            if (jQuery('.video-bg-wrapper').length) {
                var hero_video_width = isUndefined(jQuery('.video-banner').data('video-width')) ? 1920 : jQuery('.video-banner').data('video-width');
                var hero_video_height = isUndefined(jQuery('.video-banner').data('video-height')) ? 1080 : jQuery('.video-banner').data('video-height');

                var hero_video_size = imageInside({
                    containerWidth: jQuery('.video-bg-wrapper').width(),
                    containerHeight: jQuery('.video-bg-wrapper').height(),
                    imageWidth: hero_video_width,
                    imageHeight: hero_video_height
                });
                jQuery('.video-container').css({
                    width: hero_video_size.width,
                    height: hero_video_size.height,
                    top: hero_video_size.top,
                    left: hero_video_size.left
                });
            }
        });
        jQuery(window).resize();

        //SelectBox
        jQuery('.selectbox').selectBox();

        /* *****************************
         * STATIC FORM VALIDATION
         * *****************************
         */
        $('#demo_contact_page').find('#submit_static_contact_form').on('click', function () {
            var error_static_form = 0;
            $('#name_error').css('display', 'none');
            $('#email_error').css('display', 'none');
            $('#message_error').css('display', 'none');
            $('#general_error').css('display', 'none');
            $('#nf-field-1').removeClass('nf-error-field');
            $('#nf-field-3').removeClass('nf-error-field');
            $('#nf-field-5').removeClass('nf-error-field');
            if ($('#nf-field-1').val() === '') {
                $('#name_error').css('display', 'block');
                $('#nf-field-1').addClass('nf-error-field');
                error_static_form++;
            }
            if ($('#nf-field-3').val() === '') {
                $('#email_error').css('display', 'block');
                $('#nf-field-3').addClass('nf-error-field');
                error_static_form++;
            }
            if ($('#nf-field-5').val() === '') {
                $('#message_error').css('display', 'block');
                $('#nf-field-5').addClass('nf-error-field');
                error_static_form++;
            }
            if (error_static_form) {
                $('#general_error').css('display', 'block');
            } else {
                $('#contact_form_fields').css('display', 'none');
                $('#success_contact_form').css('display', 'block');
            }
            return false;
        });
        $('#demo_newsletter_form').find('#submit_newsletter_form').on('click', function () {
            var error_static_form = 0;
            $('#news_name_error').css('display', 'none');
            $('#news_email_error').css('display', 'none');
            $('#nf-field-15').removeClass('nf-error-field');
            $('#nf-field-16').removeClass('nf-error-field');
            if ($('#nf-field-15').val() === '') {
                $('#news_name_error').css('display', 'block');
                $('#nf-field-15').addClass('nf-error-field');
                error_static_form++;
            }
            if ($('#nf-field-16').val() === '') {
                $('#news_email_error').css('display', 'block');
                $('#nf-field-16').addClass('nf-error-field');
                error_static_form++;
            }
            if (!error_static_form) {
                $('#newsletter_form_fields').css('display', 'none');
                $('#success_newsletter_form').css('display', 'block');
            }
            return false;
        });

        //FEATURED CONTENT VIDEO POPUP
        $('.fetured-item .popup-video').click(function (event) {
            event.preventDefault();
            var popupContent = $(this).data('content');
            if ('local' === popupContent) {
                var featuredContentVideo = lity($(this).parent('.fetured-item').children('.popup-local-video'));
                $('.lity .video-local').get(0).play();

            }
            else {
                var featuredContentVideo = lity(popupContent);
            }
        });

        $(document).on('lity:close', function (event, instance) {
            if ($('.lity').hasClass('lity-inline')) {

                $('.lity .video-local').get(0).pause();
            }
        });

        jQuery(document).ready(function($) {
            $('a[data-rel^=lightcase]').lightcase();
            if(jQuery("#map-filter").length > 0) {
                jQuery("#map-filter").val('').change();
            }
        });

        //Floating Button trigger
        $('#floating-feed-trigger').click(function(event) {
            console.log('test');
            event.preventDefault();
            toogleFloatingFeed();
        });
        //Close button
        $('.floating-feed .close-feed').click(function(event) {
            event.preventDefault();
            toogleFloatingFeed();
        });
    
        /* *****************************
         * SEARCH FORMS
         * *****************************
         */

        var availableOptionsForParentSelect = [];
        var searchBarResetButton = jQuery('.csl_search_reset');
        
        if(jQuery('body.home').length){
            searchBarResetButton.attr('disabled', true);
        }
        
        jQuery('.csl_search_submit').on( "click", function() {
            csl_repeater_filter(this);
        });

        function csl_repeater_filter(_self){
            if ( $('.csl_search_form').find('select').hasClass('multiple-dropdown') ) {
                $('.csl_search_form').find('select:not([disabled])').SumoSelect();
            }
            else {
                $('.csl_search_form').find('select:not([disabled])').selectbox('detach').selectbox('attach');
            }
            if(jQuery(_self).hasClass('csl_filter_parent')){
                csl_get_child_filter_option(_self)
            }else{
                csl_handler_filter(_self);
            }
        }

        function csl_handler_filter(_self){
            var $this = $(_self);

            var filter_value = '';

            var form = jQuery(_self).closest('form.csl_search_form');
            var search_data =  jQuery(form).find('button.csl_search_submit');
            var types = jQuery(search_data).data('type');
            var render_function =  jQuery(search_data).data('render-function');
            var loop_args =  jQuery(search_data).data('loop-args');
            var mode = jQuery('.csl_repeater_filter.csl_filter_parent').data('mode'); //jQuery(_self).data('mode');
            var taxonomy = jQuery('.children.csl_repeater_filter').data('taxonomy'); //jQuery(_self).data('taxonomy');
            var per_page = jQuery(_self).data('per-page');
            var container = jQuery(_self).data('container');
            var formData = new FormData(form[0]);
            var aux_value = jQuery(form).find('select.csl_filter_aux').first().val() ?jQuery(form).find('select.csl_filter_aux').first().val().filter(function(e){return e}):[];
            var aux_taxonomy = jQuery(form).find('select.csl_filter_aux').first().data('taxonomy');

            if(jQuery(form).find('input.date_start').length) {
                var date_start = jQuery(form).find('input.date_start').val();
                formData.append('date_start',date_start);
            }

            if(jQuery(form).find('input.date_end').length) {
                var date_end = jQuery(form).find('input.date_end').val();
                formData.append('date_end',date_end);
            }

            if(filter_value == '') {
                var options = jQuery(_self).find('option');

                filter_value = jQuery.map(options ,function(option) {
                    if(option.value != '') {
                        return option.value;
                    }
                });
            }

            if(typeof jQuery(form).data('taxonomy') !== "undefined" &&
                typeof taxonomy  === "undefined"){
                formData.append('taxonomy',jQuery(form).data('taxonomy'));
            }else{
                formData.append('taxonomy',taxonomy);
            }
            formData.append('post_type',types);
            formData.append('render_function',render_function);
            formData.append('loop_args',loop_args);


            var filterChildren = $('.children.csl_repeater_filter');
            var filterParent = $('.csl_filter_parent.csl_repeater_filter');

            var dataChild = filterChildren.val() ?  filterChildren.val() : 'all';
            var dataParent = ! filterParent.val()
                ? Object.values(document.querySelectorAll('.csl_filter_parent.csl_repeater_filter > option'))
                    .map(function(option) {
                        return option.value;
                    })
                    .filter(function(option){
                        return !!option
                    }).join()
                : filterParent.val();

            formData.append('child_data', dataChild);
            formData.append('parent_data', dataParent);

            if($('body.home').length || $('body.our-impact').length){

                var $resetButtomDisabledAttr = filterChildren.val() ||  filterParent.val() ? false : true;
                searchBarResetButton.attr('disabled', $resetButtomDisabledAttr);

                var OptionData = new FormData(form[0]);

                OptionData.append('action','csl_map_impact_area_options');
                OptionData.append('parent_data', dataParent);
                OptionData.append('taxonomy', taxonomy);

                if(availableOptionsForParentSelect.length){
                    setAvailableOptionsForParentSelect($this, availableOptionsForParentSelect)
                }else{
                    $.ajax({
                        type: 'POST',
                        url: ajaxurl,
                        data: OptionData ,
                        processData: false,
                        contentType: false,
                        success: function (data) {
                            if(!!data){

                                availableOptionsForParentSelect = JSON.parse(data);
                                setAvailableOptionsForParentSelect($this,  availableOptionsForParentSelect);

                            }
                        }
                    })
                }
            }

            if(!$('body.home').length) {
                if(aux_taxonomy !== "" && typeof aux_taxonomy  !== "undefined") {
                    formData.append('aux_taxonomy', aux_taxonomy);
                }
                if(aux_value !== "" && typeof aux_value  !== "undefined") {
                    formData.append('aux_value', aux_value);
                }
                if(jQuery(form).data('search_mode') && typeof mode  === "undefined"){
                    formData.append('search_mode',jQuery(form).data('search_mode'));
                }else {
                    formData.append('search_mode', mode);
                }
                if(jQuery(form).data('posts_per_page') && typeof per_page  === "undefined"){
                    formData.append('posts_per_page',jQuery(form).data('posts_per_page'));
                }else {
                    formData.append('posts_per_page', per_page);
                }
                if(jQuery(form).data('posts_per_page') && typeof container === "undefined"){
                    container = jQuery(form).data('container');
                }
                if (jQuery(form).data('mandatory-ids')) {
                    formData.append('mandatory_ids', jQuery(form).data('mandatory-ids'));
                }
                if (jQuery(form).data('events-type')) {
                    formData.append('events_type', jQuery(form).data('events-type'));
                }

                var selects = jQuery(form).find('select');
                if (selects.length == 2) {
                    if(jQuery(form).find("select.multiple-dropdown").length) {
                        filter_value = jQuery(form).find('.multiple-dropdown:not(.csl_filter_aux)').val() ? jQuery(form).find('.multiple-dropdown:not(.csl_filter_aux)').val() : [];
                        if (filter_value.length == 0) {
                            var options = jQuery(form).find('.multiple-dropdown:not(.csl_filter_aux) option');

                            filter_value = jQuery.map(options, function (option) {
                                if (option.value != '') {
                                    return option.value;
                                }
                            });
                        }
                        console.log(filter_value);
                    }else {
                        filter_value = jQuery(form).find('.children').val();

                        if (filter_value == '' && !reset_status) {
                            var options = jQuery(form).find('.children option');

                            filter_value = jQuery.map(options, function (option) {
                                if (option.value != '') {
                                    return option.value;
                                }
                            });
                        }
                        if (filter_value == '') {
                            filter_value = jQuery(form).find('.csl_filter_parent').val();
                            if (filter_value == '') {
                                var options = jQuery(form).find('.csl_filter_parent option');

                                filter_value = jQuery.map(options, function (option) {
                                    if (option.value != '') {
                                        return option.value;
                                    }
                                });
                            }
                        } else {
                            formData.append('parent_id', jQuery(form).find('.csl_filter_parent').val());
                        }
                    }
                } else if (selects.length == 1) {

                    filter_value = jQuery(form).find('.csl_filter_parent').val();

                    if (filter_value == '') {
                        var options = jQuery(form).find('.csl_filter_parent option');

                        filter_value = jQuery.map(options, function (option) {
                            if (option.value != '') {
                                return option.value;
                            }
                        });
                    }

                }
                formData.append('filter_value', filter_value);
            }

            $.ajax({
                type: 'POST',
                url: ajaxurl,
                data: formData ,
                processData: false,
                contentType: false,
                success: function (data) {

                    if(mode != 'map') {
                        var blog_feed_container = jQuery(form).closest('section.blog-feed-container').find('section.blog-feed .container');
                        blog_feed_container.html(data);
                        jQuery('.match-height').matchHeight();
                        blog_feed_container.find('.row.posts div').css('opacity',0);
                        blog_feed_container.find('.row.posts div').animate({ opacity: 1 }, 500);
                    } else {
                        jQuery( ".marker" ).remove();

                        if(data.length > 0) {
                            var markers = jQuery.parseJSON(data);
                            var boundingBox = getBoundingBox(markers,'ajax');

                            //map.on('load', function (e) {});
                            if(map.popups){
                                map.popups.forEach(function(popup){
                                    popup.remove();
                                    //if(popup.isOpen()) popup.remove();
                                });
                            }

                            map.fitBounds([[boundingBox.xMin, boundingBox.yMin], [boundingBox.xMax, boundingBox.yMax]], {
                                padding: {top: 10, bottom:25, left: 15, right: 5},
                                maxZoom: 10
                            });

                            markers.forEach(function(marker) {

                                map.popups = map.popups ? map.popups : [];

                                var el = document.createElement('span');
                                var iTag =  document.createElement('i');

                                el.className = 'marker svg' + marker.color[0];
                                iTag.className = 'fas fa-map-marker-alt';
                                el.appendChild(iTag);


                                var html = '<div style="width:500px;"><span class="title">' + marker.title + '</span>';
                                html += '<span class="content">' + marker.excerpt + '</span>';
                                html += '<a class="btn" href="' + marker.url + '">Read More</a></div>';

                                var popup = new mapboxgl.Popup().setHTML(html);

                                var $marker = new mapboxgl.Marker(el)
                                    .setLngLat(marker.coordinates)
                                    .setPopup(popup)
                                    .addTo(map);

                                map.popups.push(popup);

                                el.addEventListener('click', function(){
                                    map.flyTo({center: $marker.getLngLat()});
                                })
                            });
                            replaceSvgImages();
                        }
                    }
                }
            });
        }
        
        jQuery('.csl_repeater_filter').on( "change", function(){
            if(!reset_status){
                csl_repeater_filter(this);
            }
        });
        searchBarResetButton.attr('disabled', true);
        jQuery('.event-filter .csl_search_filters select').on( "change", function(){
            enableResetButton()
        });
        function enableResetButton() {
            var changed = false;
            jQuery('.event-filter .csl_search_filters select, .event-filter .csl_search_filters input').each(function( index ) {
                if ( "" !== jQuery(this).val() ) {
                    changed = !changed ? true : true;
                }
            });
            console.log(changed);
            if (changed)  {
                searchBarResetButton.attr('disabled', false);
            }
            else {
                searchBarResetButton.attr('disabled', true);
            }
        }
        var reset_status = false;
        searchBarResetButton.click(function(e){
            e.preventDefault();
            //location.reload();
            reset_status = true;
            searchBarResetButton.attr('disabled', true);
            var form = jQuery(this).closest('form.csl_search_form');
            jQuery(form).find('select:not(:disabled)').val('');
            jQuery(form).find('input.csl_search_datepicker').val('');
            jQuery(form).find('input.search-input').val('');
            if ( $('.csl_search_form').find('select').hasClass('multiple-dropdown') ) {
                $( '.multiple-dropdown' ).each(function( index ) {
                    $(this)[0].sumo.reload();
                });
            }
            else {
                $('.csl_search_form').find('select:not([disabled])').selectbox('detach').selectbox('attach').change();
            }
            csl_repeater_filter(this);
            reset_status = false;
        });

        jQuery('.csl_search_datepicker').blur(function(e){
            e.preventDefault();
            /*var form = jQuery(this).closest('form.csl_search_form');
            var date_start = jQuery(form).find('input.date_start').val();
            var date_end = jQuery(form).find('input.date_end').val();

            if(date_start != '' && date_end != '') {
                jQuery(form).find('button.csl_date_submit').prop('disabled',false);
            }*/
        });
        $('.csl_search_form input.search-input').keyup(function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                csl_repeater_filter(this);
                return false;
            }
        });

        jQuery(document).click(function(e) {
            var ele = jQuery(e.target);
            if (!ele.hasClass("hasDatepicker") &&
                !ele.hasClass("ui-datepicker") &&
                !ele.hasClass("ui-datepicker-prev") &&
                !ele.hasClass("ui-datepicker-next") &&
                !ele.hasClass("ui-icon") &&
                !jQuery(ele).parents(".ui-datepicker").length &&
                !jQuery(ele).parent().parents(".ui-datepicker").length
            )
                jQuery(".hasDatepicker").datepicker("hide");
        });

        jQuery('.csl_search_popular').click(function(e){
            e.preventDefault();
            var id = jQuery(this).data('id');
            var form = jQuery(this).parent().parent().find('form.csl_search_form').first();
            jQuery(form).find('select.csl_filter_parent').val(id).change();
        });



        function csl_get_child_filter_option(_self){
            var filter_value = jQuery(_self).val();
            var label = jQuery(_self).data('label');
            var form = jQuery(_self).closest('form.csl_search_form');
            var taxonomy = jQuery(form).find('select.csl_filter_parent').first().data('taxonomy');
            var mode = jQuery(_self).data('mode');
            var formData = new FormData()
            if(mode != 'map') {
                formData.append('filter_value',filter_value);
                formData.append('label',label);
                formData.append('action','csl_category_children');
                formData.append('taxonomy',taxonomy);
                if(jQuery(form).data('mandatory-ids')){
                    formData.append('mandatory_ids',jQuery(form).data('mandatory-ids'));
                }

                $.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    data: formData ,
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        jQuery(form).find('select.children').html(data);
                        var options = jQuery(form).find('select.children').find('option');
                        if(jQuery(options).length <= 1) {
                            jQuery(form).find('select.children').prop('disabled',true);
                        } else {
                            jQuery(form).find('select.children').prop('disabled',false);
                        }
                        csl_handler_filter(_self);
                    }
                });
            }else{
                csl_handler_filter(_self);
            }
        }

        function csl_get_aux_filter_option ( _self ) {
            var label = jQuery(_self).data('label');
            var form = jQuery(_self).closest('form.csl_search_form');
            var filter_value = jQuery(form).find('select.csl_filter_parent').first().val();
            var taxonomy = jQuery(form).find('select.csl_filter_parent').first().data('taxonomy');
            var aux_value = jQuery(form).find('select.csl_filter_aux').first().val();
            var aux_taxonomy = jQuery(form).find('select.csl_filter_aux').first().data('taxonomy');
            var mode = jQuery(_self).data('mode');
            var formData = new FormData()
            if( mode != 'map' ) {
                formData.append('filter_value',filter_value);
                formData.append('label',label);
                formData.append('action','csl_category_children');
                formData.append('taxonomy',taxonomy);
                formData.append('aux_taxonomy',aux_taxonomy);
                formData.append('aux_value',aux_value);
                if(jQuery(form).data('mandatory-ids')){
                    formData.append('mandatory_ids',jQuery(form).data('mandatory-ids'));
                }
                if(filter_value!="" || aux_value!="" ){
                    $.ajax({
                        type: 'POST',
                        url: ajaxurl,
                        data: formData ,
                        processData: false,
                        contentType: false,
                        success: function (data) {
                            jQuery(form).find('select.children').html(data);
                            var options = jQuery(form).find('select.children').find('option');
                            if(jQuery(options).length <= 1) {
                                jQuery(form).find('select.children').prop('disabled',true);
                            } else {
                                jQuery(form).find('select.children').prop('disabled',false);
                            }
                            csl_handler_filter(_self);
                        }
                    });
                }else{
                    csl_handler_filter(_self);
                }
            }else{
                csl_handler_filter(_self);
            }
        }

        var has_make_search = false;
        jQuery('.csl_open_search').on( "click", function() {
            has_make_search = false;
            var form = jQuery(this).closest('form');
            jQuery(form).find('.csl_search_filters').fadeOut(500, function() {
                jQuery(form).find('.csl_search_field').fadeIn(500);
                jQuery(form).find('input.search-input').focus();
            });
        });

        jQuery('.csl_search_close').on("click", function(){
            var form = jQuery(this).closest('form');
            jQuery(form).find('div.csl_search_field').fadeOut(500, function() {
                jQuery(form).find('div.csl_search_filters').fadeIn(500);
            });
            if(has_make_search){
                jQuery('.csl_search_reset').click();
            }
            return false;
        });

        jQuery( function() {
            jQuery( ".csl_search_datepicker" ).datepicker({
                onSelect: function(dateText) {
                    //var form = jQuery(this).closest('form');
                    //var date_start = jQuery(form).find('input.date_start').val();
                    //var date_end = jQuery(form).find('input.date_end').val();
                    //console.log(date_start,date_end);
                    /*if(date_start != '') {
                        jQuery(form).find('input.date_end').prop('disabled',false);
                    }*/
                    /*if(date_start != '' && date_end != ''){
                        if($('.children.csl_repeater_filter').val()!=''){
                            $('.children.csl_repeater_filter').change();
                        }else{
                            $('.csl_filter_parent.csl_repeater_filter').change();
                        }
                    }*/
                    csl_repeater_filter(this);
                    enableResetButton();
                }
            });
        } );

        jQuery(".switchList").click(function(e){
            e.preventDefault();
            jQuery(".switchList").removeClass('active');
            jQuery(this).addClass('active');
            var view= jQuery(this).data('view');
            var form = jQuery(this).closest('form');
            var items = jQuery(form).parent().parent().find('div.row.posts').first().find('div.hentry');
            if(view=='list'){
                jQuery(items).each(function(i, obj) {
                    jQuery(obj).removeClass("grid-item");
                    jQuery(obj).removeClass("event-item");
                    jQuery(obj).removeClass("col-lg-3");
                    jQuery(obj).removeClass("col-md-6");
                    jQuery(obj).addClass("list-item");
                    jQuery(obj).addClass("col-lg-12");
                });
            }else{
                jQuery(items).each(function(i, obj) {
                    jQuery(obj).removeClass("list-item");
                    jQuery(obj).removeClass("col-lg-12");
                    jQuery(obj).addClass("event-item");
                    jQuery(obj).addClass("grid-item");
                    jQuery(obj).addClass("col-lg-3");
                    jQuery(obj).addClass("col-md-6");
                });
            }
            jQuery('.type-post').matchHeight();
        });
    });
    
    function setAvailableOptionsForParentSelect($this, availableOptionsForParentSelect){
        
        Object.values($this.closest('form').find('.sbHolder').first().children('ul').children('li'))
            .filter(function(option){
                var $option = $(option).children('a').attr('href');
                var $val = $option ? $option.replace('#', '') : null;
                
                if(!$val) return false;
                
                return ! availableOptionsForParentSelect.includes(parseInt($val));
                
            }).forEach(function(option){
            $(option).hide();
        });
    }
    
//Floating Feed
function toogleFloatingFeed() {
    $('.floating-feed').toggleClass('expanded');
}

/*
* Init menu configuration
* */

var bhisMobile = false;

  function renderMenuSection() {
    if (jQuery(window).width() < 1025) {
      if(bhisMobile) return;

      jQuery('.menu-item-has-children').prepend('<a href="#" class="submenu-trigger"></a>');

      //Expands menu to active child
      jQuery('.menu-section > ul.sub-menu').slideToggle( "fast" );
      jQuery('.menu-section > .submenu-trigger').toggleClass('down');

      addHandlersSection();
      bhisMobile=true;

    } else {
      if(!bhisMobile) return;

      jQuery('a.submenu-trigger').remove();
      jQuery('.sub-menu').attr({'style': ''});

      bhisMobile=false;
    }
  }


    function getBoundingBox(data,source) {
        var bounds = {}, coords, point, latitude, longitude;
        var loop;
        if(source == 'ajax') {
            loop = data.length;
        } else {
            loop = data.features.length;
        }
        for (var i = 0; i < loop; i++) {
            if(source == 'ajax') {
                coords = data[i].coordinates;
            } else {
                coords = data.features[i].geometry.coordinates;
            }

            for (var j = 0; j < coords.length; j++) {
                longitude = coords[0];
                latitude = coords[1];
                bounds.xMin = bounds.xMin < longitude ? bounds.xMin : longitude;
                bounds.xMax = bounds.xMax > longitude ? bounds.xMax : longitude;
                bounds.yMin = bounds.yMin < latitude ? bounds.yMin : latitude;
                bounds.yMax = bounds.yMax > latitude ? bounds.yMax : latitude;
            }
        }
        return bounds;
    }

    /*
     * Replace all SVG images with inline SVG
     */
    function replaceSvgImages() {
        jQuery('img.svg').each(function(){
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');
            var imgStyle = $img.attr('style');

            jQuery.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass+' replaced-svg');
                }

                // Add replaced image's classes to the new SVG
                if(typeof imgStyle !== 'undefined') {
                    $svg = $svg.attr('style', imgStyle);
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });
    }

  /*
  * Listeners to menu
  * */
  function addHandlersSection(){
    jQuery('.submenu-trigger').on("click", function(e){
      e.preventDefault();
      var classes = jQuery(this).parent().attr('class').replace(/ /g, ".");
      jQuery('.'+classes+' > ul.sub-menu').slideToggle( "fast" );
      jQuery(this).toggleClass('down');
    });
  }
  //SUBMENU TRIGGER
  $(window).load(function () {
    renderMenuSection()
  });
  $(window).resize(renderMenuSection);

})(jQuery, this);
